import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'serviceLineAppointmentQuantityPipe',
})
export class serviceLineAppointmentQuantityPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(quantity: number): string {
    const safeQuantity = typeof quantity === 'number' && !isNaN(quantity) ? quantity : 0;
    const translateKey =
      safeQuantity === 1 ? 'medicalOrder.create.amount_placeholder_single' : 'medicalOrder.create.amount_placeholder';
    return `${safeQuantity} ${this.translate.instant(translateKey)}`;
  }
}
